// extracted by mini-css-extract-plugin
export default {"reportReviewButtonContainer":"wvU2s","reportReviewButton":"Y5m_0"};